import type { SyncValidationRule, ValidationIssue } from "../types/validation";

export function manualValidation<TValue>(
  expression: boolean,
  issue: ValidationIssue,
): SyncValidationRule<TValue> {
  return {
    name: "manualValidation",
    kind: "sync",
    dependencies: [expression, issue.messageKey, issue.params],
    validate() {
      return expression ? undefined : issue;
    },
  };
}
